<template>
  <div class="col-span-12 h-full">
    <breadcrumb></breadcrumb>
    <div class="flex w-full justify-between pt-3 md:inline-flex">
      <!-- <modal-setting v-if="true" :active="true" @close="close = false"></modal-setting> -->
      <modal-reset
        v-if="statusModalReset"
        :active="statusModalReset"
        @close="statusModalReset = false"
        @confirm="confirmReset()"
      ></modal-reset>

      <modal-save
        v-if="statusSaveModal"
        :modifiedParams="modifiedParams"
        :active="statusSaveModal"
        @close="statusSaveModal = false"
        @confirm="confirmSave()"
      ></modal-save>
      <modal-change-account
        v-if="statusChangeAccountModal"
        :active="statusChangeAccountModal"
        @close="statusChangeAccountModal = false"
        @confirm="confirmChangeAccount()"
      ></modal-change-account>

      <!-- #region informações do investimento -->
      <div>
        <ontick-text size="2xl" weight="bold">{{ info.investment_name }}</ontick-text>
        <ontick-div orientation="horizontal" class="my-3 space-x-3 truncate text-xs">
          <!-- #region código do parâmetro -->
          <div
            content="Código do parâmetro"
            v-tippy="{ arrow: true, theme: 'green' }"
            class="bg-ontick-green-900 text-ontick-green-500 rounded-md"
          >
            <p class="px-2 py-1">Cód. {{ info.param_code }}</p>
          </div>
          <!-- #region ativo e mercado -->
          <div class="bg-ontick-blue-900 text-ontick-blue-500 rounded-md">
            <p class="px-2 py-1">{{ info.investment_symbol }}</p>
          </div>
          <div class="bg-ontick-orange-800 text-ontick-orange-400 rounded-md">
            <p class="px-2 py-1">{{ info.investment_market }}</p>
          </div>
        </ontick-div>
      </div>

      <!-- #region botões -->
      <div class="inline-flex items-center space-x-3">
        <!-- #region criação de novos conjuntos de parâmetros -->
        <add-params-setting></add-params-setting>

        <!-- #region deletar -->
        <ontick-button
          v-if="!selectedParameter.param_deletable"
          @click.native="statusModalReset = true"
          size="small"
          :disabled="parameterSettings.some((x) => x.running == true && x.param_id == selectedParameter.param_id)"
          :color="
            parameterSettings.some((x) => x.running == true && x.param_id == selectedParameter.param_id)
              ? 'steel'
              : 'third'
          "
          class="inline-flex"
        >
          <svg
            v-show="!submitted.reset"
            class="h-5 w-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
            ></path>
          </svg>
          <span v-show="submitted.reset" v-html="$icons.loading"></span>
          <span class="ml-2 hidden uppercase md:flex">Resetar</span>
        </ontick-button>

        <!-- #region deletar -->
        <ontick-button
          v-if="selectedParameter.param_deletable"
          @click.native="confirmDelete"
          :disabled="parameterSettings.some((x) => x.running == true && x.param_id == selectedParameter.param_id)"
          :color="
            parameterSettings.some((x) => x.running == true && x.param_id == selectedParameter.param_id)
              ? 'steel'
              : 'third'
          "
          size="small"
        >
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            ></path>
          </svg>

          <span class="ml-2 hidden uppercase md:flex">Deletar</span>
        </ontick-button>

        <!-- #region salvar -->
        <ontick-button
          :disabled="
            parameterSettings.some((x) => x.running == true && x.param_id == selectedParameter.param_id) ||
            !getSaveIsEnabled
          "
          :color="
            parameterSettings.some((x) => x.running == true && x.param_id == selectedParameter.param_id)
              ? 'steel'
              : 'primary'
          "
          size="small"
          @click.native="save"
        >
          <svg
            v-show="!submitted.save"
            class="h-5 w-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
            ></path>
          </svg>
          <span v-show="submitted.save" v-html="$icons.loading"></span>

          <span class="ml-2 hidden uppercase md:flex">Salvar</span>
        </ontick-button>
      </div>
    </div>
    <transition name="slide-fade" mode="out-in">
      <div
        v-if="parameterSettings.some((x) => x.running == true && x.param_id == selectedParameter.param_id)"
        class="text-ontick-yellow-900 flex space-x-2 py-3"
      >
        <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <p>Esta configuração está ativa. Para editar seus parâmetros, interrompa a execução desta estratégia</p>
      </div>
    </transition>
  </div>
</template>

<script>
import { spawn, Thread, Worker } from "threads";
import { mapActions, mapGetters } from "vuex";
import EventBus from "@/app/shared/utils/event_bus";
import { compareParameters } from "../../workers/edit-investment.worker";

export default {
  name: "edit-header",
  data() {
    return {
      submitted: { save: false, reset: false },
      // Status do modal para confirmar o salvar parâmetros
      statusModalReset: false,
      statusSaveModal: false,
      // Status do modal, quando o usuário altera os parâmetros e tenta alterar a conta antes de salvar as mudanças
      statusChangeAccountModal: false,
      modifiedParams: {},
    };
  },
  components: {
    ModalReset: () => import("./reset-params/reset-params.component"),
    ModalSave: () => import("./save-params/save-modal.component"),
    ModalChangeAccount: () => import("./change-account/change-account-modal.component"),
    Breadcrumb: () => import("./breadcrumb.component"),
    AddParamsSetting: () => import("./add-params-setting/add-params-setting.component"),
  },
  computed: {
    ...mapGetters({
      getParameters: "investment/getParameters",
      getSaveIsEnabled: "investment/getSaveIsEnabled",
    }),
    info() {
      return this.getParameters.info;
    },
    copy_info() {
      return this.getParameters.copy_info;
    },
    selectedParameter() {
      return this.getParameters.selectedParameter;
    },
    parameterSettings() {
      return this.getParameters.parameterSettings;
    },
  },
  created() {
    // setTimeout(() => {
    //   console.log("@ selectedParameter @", this.selectedParameter);
    //   console.log("@ info @", this.info);
    //   console.log("@ copy_info @", this.copy_info);
    // }, 4000);
    // ../../workers/edit-investment.worker.js

    EventBus.$on("CHANGE_ACCOUNT", async (payload) => {
      const worker = await spawn(new Worker("../../workers/edit-investment.worker.js"));
      const response = await worker.compareParameters(this.info.param_params, this.copy_info.param_params);
      await Thread.terminate(worker);
      if (Object.keys(response).length > 0) {
        this.statusChangeAccountModal = true;
      } else {
        this.confirmChangeAccount();
      }
    });
  },
  methods: {
    ...mapActions({
      updateParam: "investment/updateParam",
      resetParam: "investment/resetParam",
      deleteParam: "investment/deleteParam",
    }),
    confirmReset() {
      // Oculta o modal
      this.statusModalReset = false;
      this.submitted.reset = true;
      let payload = {
        investment_id: this.$route.params.investment_id,
        param_id: this.selectedParameter.param_id,
      };
      // reseta o parâmetro e, logo após, atualiza as informações do parâmetro.
      this.resetParam(payload).then((response) => {
        this.$swal({
          title: response.msg,
          icon: "success",
          iconHtml: this.$icons.swal_success,
          toast: false,
          position: "center",
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
        this.submitted.reset = false;
      });
      //
      // this.$swal({
      //   title: "Você tem certeza que deseja resetar os parâmetros?",
      //   icon: "warning",
      //   position: "center",
      //   showConfirmButton: true,
      //   showCancelButton: true,
      //   cancelButtonText: "Cancelar",
      //   confirmButtonColor: "#07a4ff",
      //   cancelButtonColor: "#f56565",
      //   confirmButtonText: "Confirmar",
      //   customClass: {
      //     popup: "sweetalert_popup",
      //     title: "sweetalert_title",
      //     confirmButton: "sweetalert_confirm_button",
      //   },
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //   }
      // });
      //
    },
    confirmDelete() {
      this.$swal({
        title: "Você tem certeza que deseja deletar?",
        icon: "warning",
        position: "center",
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#07a4ff",
        cancelButtonColor: "#f56565",
        confirmButtonText: "Confirmar",
      }).then((result) => {
        if (result.isConfirmed) {
          let payload = {
            investment_id: this.$route.params.investment_id,
            param_id: this.selectedParameter.param_id,
          };
          this.deleteParam(payload).then((response) => {
            this.$swal({
              title: response.msg,
              icon: "success",
              iconHtml: this.$icons.swal_success,
              toast: false,
              position: "center",
              timer: 2000,
              timerProgressBar: true,
              showConfirmButton: false,
            });
          });
        }
      });
    },
    async save() {
      // const worker = await spawn(
      //   new Worker("../../workers/edit-investment.worker.js")
      // );
      // const response = await worker.compareParameters(
      //   this.info.param_params,
      //   this.copy_info.param_params
      // );
      // await Thread.terminate(worker);
      // console.log("%c+----------------------------+", "font-size: 12px; font-weight: bold; color: yellow;");
      // console.log("%c|       Modified Array       |", "font-size: 12px; font-weight: bold; color: yellow;");
      // console.log("%c+----------------------------+", "font-size: 12px; font-weight: bold; color: yellow;");
      // console.log(JSON.stringify(response));

      // this.modifiedParams = response;
      this.modifiedParams = compareParameters(this.info.param_params, this.copy_info.param_params);
      this.statusSaveModal = true;
    },
    confirmSave() {
      let body = {
        investment_id: this.$route.params.investment_id,
        param_id: this.info.param_id,
        param_name: this.info.param_name,
        param_json: this.info.param_params,
      };
      // this.submitted.save = true;
      this.updateParam(body)
        .then((response) => {
          this.statusSaveModal = false;
          this.$swal({
            title: response.msg,
            icon: "success",
            iconHtml: this.$icons.swal_success,
            toast: false,
            position: "center",
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        })
        .catch((err) => {
          console.error(err);
          this.statusSaveModal = false;
          this.$swal({
            title: "Erro",
            text: "Erro ao salvar parâmetros",
            icon: "error",
            toast: false,
            position: "center",
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        });
      // .finally(() => {
      //   this.submitted.save = false;
      // });
    },
    confirmChangeAccount() {
      this.statusChangeAccountModal = false;
      // +---------------------------------------------------------------------------+
      // | Caso usuário esteja na tela de editar parâmemtros, deve ser               |
      // | redirecionado para a tela de investimentos.                               |
      // +---------------------------------------------------------------------------+
      if (this.$route.path.split("/").length == 4) {
        var path = this.$route.path.split("/");
        if (path[1] == "investments" && path[3] == "edit") {
          EventBus.$emit("ACCOUNT_CHANGE_CONFIRMED");
          this.$router.push({ path: "/investments" });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rotate-45 {
  --transform-rotate: 45deg;
  transform: rotate(45deg);
}
.group:hover .group-hover\:flex {
  display: flex;
}
.help {
  fill: #a0aec0;
  &:hover {
    fill: #19d684;
  }
}
</style>
